import { useRef } from "react"
import cx from "clsx"
import { AdminButton } from "@rawa/ui/AdminButton"
import { AdminDialog } from "./AdminDialog"
import typography from "@rawa/ui/styles/typography.module.css"
import styles from "./DiscardChangesDialog.module.css"

/** Asks before leaving a form. Escape and the corner close both keep editing. */
export function DiscardChangesDialog({
  open,
  onKeepEditing,
  onDiscard,
}: {
  open: boolean
  onKeepEditing: () => void
  onDiscard: () => void
}) {
  const keepEditing = useRef<HTMLButtonElement>(null)

  return (
    <AdminDialog
      open={open}
      onClose={onKeepEditing}
      labelledBy="discard-title"
      initialFocus={keepEditing}
      className={styles.dialog}
    >
      <h2 id="discard-title" className={cx(typography.h5, styles.title)}>
        Discard unsaved changes?
      </h2>
      <p className={styles.body}>
        Unsaved changes will be lost. Do you want to proceed?
      </p>
      <div className={styles.actions}>
        <AdminButton
          variant="outline"
          ref={keepEditing}
          onClick={onKeepEditing}
        >
          No
        </AdminButton>
        <AdminButton onClick={onDiscard}>Yes</AdminButton>
      </div>
    </AdminDialog>
  )
}
